export default "__VITE_ASSET__d0e81495__"